<template lang="pug">
b-modal#modal-overlay-image-copy(title='オーバーレイをコピーします。')
  .row
    .form-group.col-12
      label オーバーレイ名
      input(type="text",class="form-control",:value="$store.state.overlay.name",@input="updateName($event)")
  template(v-slot:modal-footer)
    b-button(variant="default",@click="copy($event)") 複製する
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    redirect_url: String
  },
  methods: {
    async copy(e){
      e.preventDefault()
      await this.$store.dispatch("overlay/copy")
      location.href = this.redirect_url
    },
    updateName(e){
      e.preventDefault()
      this.$store.commit("overlay/setName", e.target.value)
    }
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
